import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";

export default function SuccessModal({
  modalVisible,
  setModalVisible,
  status,
  text,
}) {
  useEffect(() => {
    if (modalVisible) {
      const timer = setTimeout(() => {
        setModalVisible(false);
      }, 2500);

      return () => clearTimeout(timer); // Clear the timer if the component unmounts or modalVisible changes
    }
  }, [modalVisible, setModalVisible]);

  const handleModalClose = () => {
    setModalVisible(false);
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={modalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!modalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column px-8 py-5 gap-4"
            style={{
              borderRadius: "12px",
              backgroundImage:
                "radial-gradient(circle at left top, #fff, #fff)",
            }}
          >
            <div className="flex flex-column justify-content-center align-items-center gap-2">
              <img
                style={{ width: "125px" }}
                src={
                  status === "success"
                    ? "Laundy_App_Icons_Gifs/Success.gif"
                    : "Laundy_App_Icons_Gifs/Failed.gif"
                }
                alt="logo"
              />
              <div className="flex justify-content-center align-items-center gap-2" >
                <p className="text-black-alpha-90 text-4xl text-primary-50 font-semibold">
                  {status}
                  {"! "}
                </p>
                <img
                  style={{ width: "25px" }}
                  src={
                    status === "success"
                      ? "Laundy_App_Icons_Gifs/Other_Icons/Success.png"
                      : "Laundy_App_Icons_Gifs/Other_Icons/Failed.png"
                  }
                  alt="logo"
                />
              </div>
            </div>
            <div className="inline-flex flex-column align-items-center gap-2">
              <label htmlFor="username" className=" text-2xl font-semibold text-center">
                {text}
              </label>
            </div>
          </div>
        )}
      ></Dialog>
    </div>
  );
}
